import { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
// import { useJsApiLoader } from '@react-google-maps/api';
import { ConfigProvider, Typography } from 'antd';
import { ErrorMessageContext } from '../../../context/ErrorMessageContext';

// const libraries = ['places'];
const { Text } = Typography;

function AddressFetcher({
  location = {},
  title = 'Location',
  fontSize = '0.875rem',
  type = 'text',
}) {
  const { addErrorMessage } = useContext(ErrorMessageContext);
  // const { isLoaded } = useJsApiLoader({
  //   id: 'google-map-script',
  //   googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_JS_API_KEY,
  //   libraries,
  // });
  const isLoaded = false;
  const [address, setAddress] = useState('Loading address...');
  const [lastFetched, setLastFetched] = useState(0);
  const throttleTime = 60000;

  useEffect(() => {
    try {
      const { latitude, longitude } = location;
      if (isLoaded && latitude && longitude) {
        const now = Date.now();
        if (now - lastFetched >= throttleTime) {
          const geocoder = new window.google.maps.Geocoder();
          geocoder.geocode(
            { location: { latitude, longitude } },
            (results, status) => {
              if (status === 'OK' && results[0]) {
                setAddress(results[0].formatted_address);
                setLastFetched(now);
              } else {
                setAddress(`${latitude}, ${longitude}`);
              }
            }
          );
        }
      } else {
        setAddress(`${latitude}, ${longitude}`);
      }
    } catch {
      addErrorMessage(
        'Unable to fetch current address! Please try again after sometime.'
      );
    }
  }, [isLoaded, location, lastFetched]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Typography: {
            fontSize,
          },
        },
      }}
    >
      <Text
        data-cy="address-text"
        style={{
          color:
            type === 'map' ? '#000000' : 'var(--primary-text-color, #ffffff)',
        }}
      >
        {title}: <b>{address}</b>
      </Text>
    </ConfigProvider>
  );
}

AddressFetcher.propTypes = {
  location: PropTypes.object,
  title: PropTypes.string,
  fontSize: PropTypes.string,
  type: PropTypes.string,
};

export default AddressFetcher;
